export * from './stores/app.store'
export * from './types/collection-player.type'
export * from './utils/node.util'
import { clear as clearNavigationCache } from '@collection-player/composables/navigation-cache.use'
import { clear as clearImageCache } from '@collection-player/composables/image-cache.use'

export const clearCache = () => {
  clearNavigationCache()
  clearImageCache()
}
